const API_BASE_URL = process.env.REACT_APP_API_ADDRESS;

/**
 * Fetches the secure one-time iframe URL and configuration from System A backend.
 * 
 * @param {string} resource - The name of the resource to embed (e.g., "dashboard/sales-overview").
 * @param {object} params - Optional parameters to pass to the embedded resource.
 * @returns {Promise<object>} Returns { iframe_url, expires_at, expected_origin } on success.
 */
export const getIframeEmbedConfig = async (resource, params = {}) => {
    const response = await fetch(`${API_BASE_URL}/iframes-embed/embeds`, {
        method: 'POST',
        headers: {
            // Using the token from your auth system to prove the user is logged in
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ resource, params }),
    });

    // Handle specific error codes dictated by the specification[cite: 1]
    if (!response.ok) {
        let errorMessage = `HTTP error! status: ${response.status}`;
        try {
            const errorData = await response.json();
            errorMessage = errorData.error || errorMessage;
        } catch (e) {
            // Fallback if response isn't JSON
        }

        if (response.status === 401) {
            console.error("User is not authenticated.");
        } else if (response.status === 403) {
            console.error("User does not have permission for this resource.");
        } else if (response.status === 422) {
            console.error("Parameter validation failed.");
        } else if (response.status === 502 || response.status === 504) {
            console.error("System B is temporarily unavailable or timed out.");
        }

        throw new Error(errorMessage);
    }

    // Returns { iframe_url, expires_at, expected_origin }[cite: 1]
    return await response.json();
};